import React, {useEffect} from 'react';
import './App.css'
import ReactNotification from 'react-notifications-component';
import {Redirect, Route, Router, Switch} from "react-router";
import {appHistory} from "./utils/history";
import {ProtectedRoute, SigninRoute} from "./utils/protectedRoute";
import {Signin} from "./pages/admin/Signin/Signin";
import 'antd/dist/antd.css';
import {Template} from "./components/Template/Template";
import {getIsLoading} from "./store/selectors/loaderSelectors";
import {Loader} from "./components/common/Loader/Loader";
import {useDispatch, useSelector} from "react-redux";
import 'react-notifications-component/dist/theme.css';
import {Orders} from "./pages/admin/Orders/Orders";
import {Settings} from "./pages/admin/Settings/Settings";
import dayjs from "dayjs"
import {logoutUser} from "./store/reducers/admin/authReducer";
import {HomePage} from "./pages/user/HomePage/HomePage";
import {CreatePackage} from "./pages/user/CreatePackage/CreatePackage";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import 'ant-design-pro/dist/ant-design-pro.css';
import {Success} from "./pages/user/Success/Success";
import {FAQ} from "./pages/user/FAQ/FAQ";
import {PageNotFound} from "./pages/Page404/Page404";
import {PackageInfo} from "./pages/user/PackageInfo/PackageInfo";
import "react-image-gallery/styles/scss/image-gallery.scss";

function App() {

    const isLoading = useSelector(getIsLoading)
    const dispatch = useDispatch()

    useEffect(() => {
        const now = dayjs().unix()
        const validTo = dayjs(localStorage.getItem('validTo') as string || sessionStorage.getItem('validTo') as string).unix()
        if (now >= validTo) {
            dispatch(logoutUser())
        }
    }, []);


    return <div className='app'>
        <ReactNotification/>
        {isLoading && <Loader/>}
        <Router history={appHistory}>
            <Template>
                <Switch>
                    <Route exact path='/' render={() => <HomePage/>}/>
                    <Route path='/create-package/:_id' render={() => <CreatePackage/>}/>
                    <Route path='/package-info/:_id' render={() => <PackageInfo/>}/>
                    <Route path='/success' render={() => <Success/>}/>
                    <Route path='/faq' render={() => <FAQ/>}/>

                    <SigninRoute
                        exact
                        path="/signin"
                        render={() => <Signin/>}
                    />


                    <ProtectedRoute
                        exact
                        path="/admin"
                        render={() => <Redirect to={'/admin/orders'}/>}
                    />
                    <ProtectedRoute
                        exact
                        path="/admin/orders"
                        render={() => <Orders/>}
                    />
                    <ProtectedRoute
                        exact
                        path="/admin/settings"
                        render={() => <Settings/>}
                    />


                    <Route path='*' render={() => <PageNotFound/>}/>
                </Switch>
            </Template>
        </Router>

    </div>
}

export default App;
